import React from "react";

import { Box, Typography, makeStyles } from "@material-ui/core";
import { Brand } from "@ds-developer/models";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  box: {
    marginTop: "129px",
    paddingBottom: "100px",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
  },
  text: {
    "&.bsm": {
      fontWeight: 300,
    },
  },
}));

interface Props {
  brand?: string;
}

export const AcceptanceFooter: React.FC<Props> = ({ brand }) => {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <Typography
        variant="body1"
        align="center"
        className={clsx(classes.text, {
          bsm: brand === Brand.Bsm,
        })}
      >
        &copy; Automobile Association Developments Limited is an appointed
        representative of Automobile Association Insurance Services Limited for
        regulated consumer hire and insurance distribution activities.
        Automobile Association Insurance Services Limited is authorised and
        regulated by the Financial Conduct Authority.
      </Typography>
    </Box>
  );
};
